module.exports = __webpack_public_path__ + "img/GitHub-Mark.b15eedbd.png";